module.exports = __webpack_public_path__ + "img/button-right.d3d5587b.png";